import { DynamicSchema } from '@soniq/schema'
import { definitions } from '../../.types/Location.schema.json'
import { LocationSchema } from '../../.types/Location.schema'

export type { LocationSchema } from '../../.types/Location.schema'
export const locationJsonSchema = {
  ...definitions.LocationSchema,
  definitions,
}
export const locationJsonSchemaWithRequiredAddress = {
  ...locationJsonSchema,
  properties: {
    ...locationJsonSchema.properties,
    address1: { type: 'string' },
    city: { type: 'string' },
    postcode: { type: 'string' },
  },
}
export const locationSchema = DynamicSchema.new<LocationSchema>({
  id: 'LocationSchema',
  jsonSchema: locationJsonSchema,
})
export * from './guards'
export * from './types'
